// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'babel-polyfill'
import App from './App'
import router from './router'
import store from './store'
import iView from 'iview'
import i18n from '@/locale'
import config from '@/config'
import importDirective from '@/directive'
import 'iview/dist/styles/iview.css'
import './index.less'
import '@/assets/icons/iconfont.css'
require("babel-polyfill"); //es5
// import "babel-polyfill"; //es6
// import '@/mock'
// 实际打包时应该不引入mock
import env from '../config/env'
/* eslint-disable */
env === 'development' ? require('@/mock') : ''

Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value)
})

Vue.use(iView);

Vue.config.productionTip = false

import fullCalendar from 'vue-fullcalendar'

Vue.component('full-calendar', fullCalendar)

// 一键复制
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;

// 全局样式
// import ('./assets/web/style/common.scss')

// md5加密
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

import qs from 'qs'; //序列化  post请求用
Vue.prototype.$qs = qs;

// import ('./config/axios')


/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config
/**
 * 注册指令
 */
importDirective(Vue)

new Vue({
  el: '#app',
  router,
  i18n,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js